import React from 'react'
import Flag from 'react-world-flags'
import { ReactComponent as ArrowDownIcon } from 'assets/svg/shared/arrow_down.svg'

export default function DidSelect({ toggleModal, selectedItem, isUpdateInProgress, isDataEmpty, isHidden }) {
    const destinationAdditionals = selectedItem?.destination_additionals
    const { did_title: didTitle } = destinationAdditionals || ''

    return (
        !isHidden && (
            <div
                onClick={toggleModal}
                className={`dialpad__select d-flex ${
                    isDataEmpty ? 'justify-content-center no-select' : 'justify-content-between'
                }`}
            >
                {isUpdateInProgress ? (
                    <div className="skeleton"></div>
                ) : (
                    <>
                        {selectedItem && (
                            <div className="dialpad__select__support showIn">
                                {selectedItem.code && (
                                    <Flag
                                        className="dialpad__select__support-ico"
                                        code={selectedItem.code.toLowerCase()}
                                        height="12"
                                    />
                                )}
                                <div className={`dialpad__select__details ${didTitle && 'align-items-center'}`}>
                                    {didTitle && <span className="dialpad__select__text-truncate">{didTitle}</span>}
                                    <span className="dialpad__select__text-truncate">
                                        {selectedItem.destination_number}
                                    </span>
                                </div>
                            </div>
                        )}
                        {!isDataEmpty && (
                            <span className="dialpad__select-toggler showIn">
                                <ArrowDownIcon width={17} />
                            </span>
                        )}
                    </>
                )}
            </div>
        )
    )
}
